import React, { useEffect } from "react";
import { Button, Modal, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import Input from "components/Input";

import * as Styled from "./styles";

interface CoverageAreaData {
  mapLink: string;
}

interface EditModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: CoverageAreaData) => void;
}

const EditMapModal: React.FC<EditModalProps> = ({
  isOpen,
  onClose,
  onSave,
}) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<CoverageAreaData>();

  useEffect(() => {
    reset();
  }, [isOpen, reset]);

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Styled.Content>
        <Typography variant="h6" mb={2}>
          {t("importCoverageAreaMapFromGoogleMaps")}
        </Typography>

        <Typography display="flex" mb={1}>
          <Styled.Strong>1 -</Styled.Strong>
          {t("createOrEditMapUsingAccountOn")}
          <Styled.Link
            href="https://www.google.com/maps/d/u/0/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Google My Maps
          </Styled.Link>
          ;
        </Typography>
        <Typography display="flex" mb={1}>
          <Styled.Strong>2 -</Styled.Strong>
          {t("insertThePinInTheExactLocation")};
        </Typography>

        <Typography display="flex">
          <Styled.Strong>3 -</Styled.Strong>
          {t("drawOneOrMoreAreas")};
        </Typography>
        <Typography>* {t("anAreaCannotIntersectWithTheSameArea")}.</Typography>
        <Typography mb={1}>* {t("twoCoverageAreasCanOverlap")}.</Typography>

        <Typography display="flex" mb={1}>
          <Styled.Strong>4 -</Styled.Strong>
          {t("shareTheMapUsingAnyoneWithTheLinkCanSeeIt")}; ;
        </Typography>

        <Typography display="flex" mb={1}>
          <Styled.Strong>5 -</Styled.Strong>
          {t("copyAndPasteTheLinkInTheFieldAbove")};
        </Typography>

        <Typography mb={1} component="span">
          <Styled.Strong>6 -</Styled.Strong>
          {t("Wait2MinutesBeforeSendingInformation")}.
        </Typography>

        <Styled.TypeLinkContainer onSubmit={handleSubmit(onSave)}>
          <Input
            name="mapLink"
            error={errors.mapLink}
            label={t("addCoverageArea")}
            placeholder="https://www.google.com/maps/d/u/0/edit?mid=312312smnjbnneknNA32sE4&usp=sharing"
            register={register}
            fullWidth
            registerOptions={{
              required: t("requiredField"),
              pattern: {
                value:
                  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/,
                message: t("invalidUrl"),
              },
            }}
          />
          <Styled.ActionsContainer>
            <Button color="secondary" variant="contained" onClick={onClose}>
              {t("back").toUpperCase()}
            </Button>
            <Button variant="contained" type="submit">
              {t("saveMap").toUpperCase()}
            </Button>
          </Styled.ActionsContainer>
        </Styled.TypeLinkContainer>
      </Styled.Content>
    </Modal>
  );
};

export default EditMapModal;
